import React, {useState} from "react";
import {Button, Form, Table} from "react-bootstrap";

import {fetchAssignmentList} from "../actions/AssignmentActions"
import {useDispatch, useSelector} from "react-redux";

export default function ProjectOverview() {

    const tableSize = 18;
    const [slice, setSlice] = useState([0, tableSize]);
    const [selected, setSelected] = useState(null);
    const [showUnassigned, setShowUnassigned] = useState(false);

    const projectId = useSelector((state) => state.projectReducer.projectId);
    const massGroupSummaries = useSelector((state) => {
        if (showUnassigned) {
            return state.projectReducer.massGroupSummaries;
        } else {
            return state.projectReducer.massGroupSummaries.filter(massGroup => massGroup.assigned > 0);
        }
    });

    const dispatch = useDispatch();

    const handleNextPage = () => {

        const newStart = Math.min(slice[0] + tableSize - 1, massGroupSummaries.length - tableSize);
        const newEnd = newStart + tableSize;
        setSlice([newStart, newEnd]);
    };

    const handlePreviousPage = () => {

        const newStart = Math.max(0, slice[0] - tableSize - 1);
        const newEnd = newStart + tableSize;
        setSlice([newStart, newEnd]);
    };

    const renderTableBody = () => {

        let selectedStyle = {
            backgroundColor: "#5ef2ff"
        };

        return (
            massGroupSummaries.slice(slice[0], slice[1]).map(massGroup =>

                <tr key={massGroup.massGroup} style={massGroup.massGroup === selected ? selectedStyle : {}}
                    onClick={() => {

                        setSelected(massGroup.massGroup);
                        dispatch(fetchAssignmentList(projectId, massGroup.massGroup))
                    }}>
                    <td align="right">{massGroup.massGroup}</td>
                    <td align="right">{massGroup.structureIds.length === 0 ? '-' : massGroup.structureIds.length}</td>
                    <td align="right">{massGroup.assigned}</td>
                    <td align="right">{massGroup.unassigned}</td>
                </tr>)
        );
    };

    const renderEmptyTableBody = (size) => {
        return (
            [...Array(size)].map((e, index) =>
                <tr key={index}>
                    <td align="right">0</td>
                    <td align="right"/>
                    <td align="right"/>
                    <td align="right"/>
                </tr>)
        );
    };

    return <div>
        <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th>Mass</th>
                <th>Structures</th>
                <th colSpan="2">Spectra</th>
            </tr>
            </thead>
            <tbody>
            {massGroupSummaries.length === 0 ? renderEmptyTableBody(tableSize) : renderTableBody()}
            </tbody>
        </Table>
        <Form className="my-1">
            <Button size="sm" variant="outline-secondary" disabled={slice[0] === 0}
                    onClick={handlePreviousPage}>
                &lt;
            </Button>
            <Button size="sm" variant="outline-secondary"
                    disabled={slice[1] >= massGroupSummaries.length}
                    onClick={handleNextPage}>
                &gt;
            </Button>
            <Checkbox label="Show unassigned" isSelected={showUnassigned} onCheckboxChange={() => setShowUnassigned(!showUnassigned)}/>
        </Form>
    </div>
}

const Checkbox = ({label, isSelected, onCheckboxChange}) => (
    <div className="form-check">
        <label>
            <input
                type="checkbox"
                name={label}
                checked={isSelected}
                onChange={onCheckboxChange}
                className="form-check-input"
            />
            {label}
        </label>
    </div>
);
